module.exports = __webpack_public_path__ + "img/goal-eleven-br.f7f010dc.png";